import React from "react"
import { Link } from "react-router-dom"
import style from "./Footer.module.css"
import Youtube from "../../icons/Youtube"
import Instagram_dark from "../../icons/Instagram_dark"

function Footer() {
  return (
    <footer className={style.footer}>
      <div className={style.footerContainer}>
        {/* Brand Column */}
        <div className={style.brandCol}>
          <h3 className={style.brandTitle}>Dr. Malu Mahendran</h3>
          <p className={style.brandDesc}>
            Dedicated to holistic wellness, authentic natural care, and empowering your daily health journey.
          </p>
          <div className={style.socialList}>
            <a
              href="https://youtube.com/@drmalumahendran?si=5HX-5le2HezuTkdZ"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="YouTube"
              className={style.socialIcon}
            >
              <Youtube />
            </a>
            <a
              href="https://www.instagram.com/dr_malumahendran?igsh=MXI4NHdmbGUxOHdpYw=="
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagram"
              className={style.socialIcon}
            >
              <Instagram_dark />
            </a>
          </div>
        </div>

        {/* Quick Links */}
        <div className={style.linkCol}>
          <h4>Quick Links</h4>
          <ul>
            <li>
              <Link to="/">Home</Link>
            </li>
            <li>
              <Link to="/about-us">About Us</Link>
            </li>
            <li>
              <Link to="/account">My Account</Link>
            </li>
            <li>
              <Link to="/orders">My Orders</Link>
            </li>
          </ul>
        </div>

        {/* Policies */}
        <div className={style.linkCol}>
          <h4>Customer Care & Policies</h4>
          <ul>
            <li>
              <Link to="/refund-policy">Refund Policy</Link>
            </li>
            <li>
              <Link to="/privacy-policy">Privacy Policy</Link>
            </li>
            <li>
              <Link to="/terms-of-service">Terms of Service</Link>
            </li>
            <li>
              <Link to="/shipping-policy">Shipping Policy</Link>
            </li>
          </ul>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className={style.bottomBar}>
        <div className={style.bottomContainer}>
          <p>© {new Date().getFullYear()} Dr. Malu Mahendran. All rights reserved.</p>
          <div className={style.trustBadges}>
            <span>🌿 100% Natural Care</span>
            <span>🔒 Secure Checkout</span>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer
